import { Button } from "element-ui";
import FormBase from "./FormBase";
export default {
  name: "AceButton",
  data() {
    return {
      isAuth: true,
    };
  },
  mixins: [Button, FormBase],
  computed: {
    buttonDisabled() {
      return (
        //1.是否开启禁用。
        //2.父元素el-form是否开启经用。
        //3.processShell下当前步骤的操作标识时候允许操作。
        this.disabled || (this.elForm || {}).disabled || this.isOperationDisabled() || !this.isAuth
      );
    },
  },
};
